import CoreModule from './core';
import PageModule from "./page-modules/corp-ed";

class App {
	constructor() {
		window.addEventListener('load', () => {
			this.coreModule = new CoreModule();
			this.pageModule = new PageModule();
		}, false);
	}
}

const app = new App();